import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

// 引入 echarts
import * as echarts from 'echarts'
// 全局挂载 echarts
Vue.prototype.$echarts = echarts

// 全局挂载axios实例和api对象
import request, { api } from '@/utils/api'
Vue.prototype.$request = request
Vue.prototype.$api = api

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
